import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const InvoiceLineItemSchema = withDefaults({
  type: 'invoice-line-item',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'lineItemType',
    },
    {
      kind: 'belongsTo',
      name: 'invoice',
      type: 'invoice',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default InvoiceLineItemSchema;
